import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

const MainBox = styled.main`
  width: 100%;
  height: 100%;
  overflow: hidden;

  ${(props) => (props.type === 'bookMenu' && css`
    background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main_bg_phonics_pop.png) center /contain no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column-gap: 80px;
    padding-top: 296px;
  `)}

  ${(props) => (props.type === 'menu' && css`
    position: relative;
    background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main_bg_phonics_pop.png) center /contain no-repeat;
  `)}

  ${(props) => props.type === 'ebook' && css`
    position: relative;
    background-color: #f2f2f2;
  `}
  
  ${(props) => props.type === 'audio' && css`
    display: grid;
    background: center /contain no-repeat;
    position: relative;
    grid-template-columns: 20% 80%;
    grid-template-rows: auto 155px 140px;
    grid-row-gap: 62px;

    ${props.book === 0 && 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_book1_bg_small.png);'} 
    ${props.book === 1 && 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_book2_bg_small.png);'} 
    ${props.book === 2 && 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_book3_bg_small.png);'} 
  `}

  ${(props) => props.type === 'resource' && css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/LearningResources/LR_mainbg.png) center / cover no-repeat;
  `}
`;

export const Main = (props) => {
  const state = useSelector((state) => state);
  return (
    <MainBox type={props.type} book={state.book.current_book}>{props.children}</MainBox>
  );
};

Main.propTypes = {
  type : PropTypes.string.isRequired
};

Main.defaultProps = {
  type : 'bookMenu'
};